var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerpetual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-3{fill:#0071bc}\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M442.69 408.62H95.85V52.85C95.85 45.76 90.1 40 83 40H57.31c-7.09 0-12.85 5.75-12.85 12.85v381.46c0 14.19 11.5 25.69 25.69 25.69h372.53c7.09 0 12.85-5.75 12.85-12.85v-25.69c0-7.09-5.75-12.85-12.85-12.85Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m280.42 136.18-76.41-7.71 8.05 22.23-31.72 85.23 100.08-99.75z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#39beec"
    },
    d: "m126.94 141.93 76.41 7.7-8.05-22.23 31.72-85.22-100.08 99.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#fff",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 30
    },
    d: "m149.33 357.39 82.56-82.56 82.56 23.14 57.49-57.49-48.86-48.86h99.18v99.18l-50.32-50.32"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    d: "m328.34 185.96 99.18 5.66-7.99 88.43-91.19-94.09z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerpetual);
export default __webpack_public_path__ + "static/media/Perpetual.e26f699ca9bcdd96d66feac8cda80453.svg";
export { ForwardRef as ReactComponent };